import * as React from 'react';

interface IHeaderLinkProps {
  to: string | null;
  className?: string;
  onClick?: (e: any) => void;
}

export default class HeaderLink extends React.Component<IHeaderLinkProps> {

  public constructor(props: IHeaderLinkProps) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  public render() {
    const { to } = this.props;
    
    const linkProps = {...this.props};
    delete(linkProps.to);

    const webUrl = process.env.REACT_APP_WEB_URL;

    return (
      <a 
        {...linkProps}
        href={to === null ? '#' : (/^(http:|https:)/i).test(to) ? to : `${webUrl}${to}`}
        onClick={this.onClick} 
      >
        {this.props.children}
      </a>
    );
  }

  private onClick(e: any) {
    if (this.props.to === null) {
      e.preventDefault();
    }
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/Header/components/Link/Link.tsx